import { useTranslation } from 'react-i18next';

/**
 * Reusable 404 view.
 * Used by the catch-all route and by pages that resolve to "not found"
 * after fetching (e.g. a tender UUID that doesn't exist).
 */
export default function NotFound() {
  const { t } = useTranslation();

  return (
    <main
      id="main-content"
      className="flex flex-col items-center justify-center min-h-[60vh] gap-4"
    >
      <h1 className="text-4xl font-bold text-gray-800">404</h1>
      <p className="text-gray-500">{t('common.pageNotFound')}</p>
      <a
        href="/dashboard"
        className="text-brand-600 underline hover:text-brand-800 focus:outline-none focus:ring-2 focus:ring-brand-500 rounded"
      >
        {t('common.goToDashboard')}
      </a>
    </main>
  );
}
